import styled from "styled-components";

export const StyledError = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 200px;
`;

export const StyledImgError = styled.img`
    width: 250px;
    border-radius: 34px;
`;

export const StyledMessageError = styled.h1`
    text-align: center;
    margin: 28px 20px;
`;
